var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLink = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentcolor",
  viewBox: "0 0 16 16",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M6.75 5a.75.75 0 0 1-.75.75H5a2.25 2.25 0 0 0 0 4.5h1a.75.75 0 0 1 0 1.5H5a3.75 3.75 0 1 1 0-7.5h1a.75.75 0 0 1 .75.75zm2.5 6a.75.75 0 0 1 .75-.75h1a2.25 2.25 0 0 0 0-4.5h-1a.75.75 0 0 1 0-1.5h1a3.75 3.75 0 1 1 0 7.5h-1a.75.75 0 0 1-.75-.75z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M10 8.75a.75.75 0 0 0 0-1.5H6a.75.75 0 0 0 0 1.5h4z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgLink);
export default ForwardRef;